import type { DataGridColumn } from './VDataGridColumnV2.vue';

/**
 * Сохранённый фильтр колонки VDataGridV2: тип контрола, его пропсы и то, как значение
 * уходит на сервер. Передаётся в колонку пропом :filter — колонка становится фильтруемой,
 * а явно заданные filter-* пропы колонки перекрывают соответствующие поля фильтра.
 */
export default class GridFilter {
  filterType:     DataGridColumn['filterType'];
  filterProps:    Record<string, unknown>;
  filterSendName: string | null;
  filterIdentity: string | string[] | null;

  constructor(
    filterType:     DataGridColumn['filterType'],
    filterProps:    Record<string, unknown>,
    filterSendName: string | null = null,
    filterIdentity: string | string[] | null = null,
  ) {
    this.filterType     = filterType;
    this.filterProps    = filterProps;
    this.filterSendName = filterSendName;
    this.filterIdentity = filterIdentity;
  }
}
